/**
 * Representation of com.rygen.billing.domain.shipment.ShipmentStatus
 */
export enum ShipmentFinancialStatus {
  /**
   * Shipment created, but has not been matched to any Carrier Invoices
   */
  NEW = 'NEW',
  /**
   * One or more invoices have been received and have not been audited
   */
  INVOICE_RECEIVED = 'INVOICE_RECEIVED',
  /**
   * One or more invoices have failed audit and are awaiting resolution
   */
  INVOICE_DISCREPANCY = 'INVOICE_DISCREPANCY',
  /**
   * Hold, one or more invoices are ready to be queued for billing, all have completed audit, but the shipment is not
   * ready to be billed. Common use-case is the invoices to be ready, but the shipment has not yet been delivered.
   */
  HOLD = 'HOLD',
  /**
   * One or more invoices are queued for billing and all have completed audit
   */
  READY_FOR_BILLING = 'READY_FOR_BILLING',
  /**
   * One or more invoices is in BILLED status and all related invoices have been billed to the client
   */
  BILLED = 'BILLED',
  /**
   * All related invoices have been paid by client and one or more Carrier Invoice has NOT been paid
   */
  PAID = 'PAID',
  /**
   * All related invoices have been paid by client AND carrier has been paid
   */
  COMPLETE = 'COMPLETE',
  /**
   * Shipment has been cancelled
   */
  CANCELLED = 'CANCELLED',
}
